import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MsalGuard } from './msal';

import { HomeComponent } from './pages/home/home.component';
import { UnAuthorizedComponent } from './pages/unauthorized/unauthorized.component';
// import { LoadRouteComponent } from './pages/document-control/load-route/load-route.component';

const routes: Routes = [
  { path: '', component: HomeComponent, pathMatch: 'full', canActivate: [MsalGuard]},

  { path: 'home', component: HomeComponent, pathMatch: 'full', canActivate: [MsalGuard] },

  {
    path: 'box-level',
    loadChildren: () => import('./pages/box-level/box-level.module').then(m => m.BoxLevelModule),
    canActivate: [MsalGuard], data: { breadcrumb: 'Box Level', navigate: false }
  },
  {
    path: 'reports',
    loadChildren: () => import('./pages/reports/reports.module').then(m => m.ReportsModule),
    canActivate: [MsalGuard], data: { breadcrumb: 'Reports', navigate: false }
  },
  {
    path: 'history',
    loadChildren: () => import('./pages/history/history.module').then(m => m.HistoryModule),
    canActivate: [MsalGuard], data: { breadcrumb: 'History', navigate: false }
  },
  {
    path: 'administration',
    loadChildren: () => import('./pages/administration/administration.module').then(m => m.AdministrationModule),
    canActivate: [MsalGuard], data: { breadcrumb: 'Administration', navigate: false }
  },
  {
    path: 'returnables',
    loadChildren: () => import('./pages/returnables/returnables.module').then(m => m.ReturnablesModule),
    canActivate: [MsalGuard], data: { breadcrumb: 'Returnables', navigate: false }
  },
  {
    path: 'export-parts',
    loadChildren: () => import('./pages/export-parts/export-parts.module').then(m => m.ExportPartsModule),
    canActivate: [MsalGuard], data: { breadcrumb: 'Export Parts', navigate: false }
  },
  {
    path: 'document-control',
    loadChildren: () => import('./pages/document-control/document-control.module').then(m => m.DocumentControlModule),
    canActivate: [MsalGuard], data: { breadcrumb: 'Document Control', navigate: false }
  },
  {
    path: 'unload',
    loadChildren: () => import('./pages/unload/unload.module').then(m => m.UnloadModule),
    canActivate: [MsalGuard], data: { breadcrumb: 'Unload', navigate: false }
  },
  {
    path: 'reload',
    loadChildren: () => import('./pages/reload/reload.module').then(m => m.ReloadModule),
    canActivate: [MsalGuard], data: { breadcrumb: 'Reload', navigate: false }
  },
  { path: 'unauthorized/:error/:logout', component: UnAuthorizedComponent },
  { path: '**', component: UnAuthorizedComponent},

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }